import React, { useState } from 'react';
import { User, Mail, Phone, MapPin, Calendar, Edit, Save, X } from 'lucide-react';
import './MyAccount.css';

const MyAccount = () => {
  const [isEditing, setIsEditing] = useState(false);
  const [profileData, setProfileData] = useState({
    name: 'Dr. John Smith',
    email: 'dr.smith@hido.com',
    phone: '(555) 123-4567',
    location: 'San Francisco, CA',
    department: 'Cardiology',
    joinDate: 'January 15, 2022',
    bio: 'Experienced cardiologist with over 10 years of practice in medication management and patient care.'
  });

  const [editData, setEditData] = useState({ ...profileData });

  const handleEdit = () => {
    setIsEditing(true);
    setEditData({ ...profileData });
  };

  const handleSave = () => {
    setProfileData({ ...editData });
    setIsEditing(false);
  };

  const handleCancel = () => {
    setEditData({ ...profileData });
    setIsEditing(false);
  };

  const handleInputChange = (field, value) => {
    setEditData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  return (
    <div className="my-account-page">
      <div className="account-header">
        <h1>My Account</h1>
        <p>Manage your profile information and account settings</p>
      </div>

      <div className="account-content">
        <div className="profile-card">
          <div className="profile-header">
            <div className="profile-avatar">
              <img 
                src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=120&h=120&fit=crop&crop=face&auto=format" 
                alt="Profile" 
                className="avatar-large"
              />
              <button className="change-photo-btn">Change Photo</button>
            </div>
            <div className="profile-actions">
              {!isEditing ? (
                <button className="edit-btn" onClick={handleEdit}>
                  <Edit size={16} />
                  Edit Profile
                </button>
              ) : (
                <div className="edit-actions">
                  <button className="save-btn" onClick={handleSave}>
                    <Save size={16} />
                    Save
                  </button>
                  <button className="cancel-btn" onClick={handleCancel}>
                    <X size={16} />
                    Cancel
                  </button>
                </div>
              )}
            </div>
          </div>

          <div className="profile-details">
            <div className="detail-group">
              <label className="detail-label">
                <User size={16} />
                Full Name
              </label>
              {isEditing ? (
                <input
                  type="text"
                  value={editData.name}
                  onChange={(e) => handleInputChange('name', e.target.value)}
                  className="detail-input"
                />
              ) : (
                <span className="detail-value">{profileData.name}</span>
              )}
            </div>

            <div className="detail-group">
              <label className="detail-label">
                <Mail size={16} />
                Email Address
              </label>
              {isEditing ? (
                <input
                  type="email"
                  value={editData.email}
                  onChange={(e) => handleInputChange('email', e.target.value)}
                  className="detail-input"
                />
              ) : (
                <span className="detail-value">{profileData.email}</span>
              )}
            </div>

            <div className="detail-group">
              <label className="detail-label">
                <Phone size={16} />
                Phone Number
              </label>
              {isEditing ? (
                <input
                  type="tel"
                  value={editData.phone}
                  onChange={(e) => handleInputChange('phone', e.target.value)}
                  className="detail-input"
                />
              ) : (
                <span className="detail-value">{profileData.phone}</span>
              )}
            </div>

            <div className="detail-group">
              <label className="detail-label">
                <MapPin size={16} />
                Location
              </label>
              {isEditing ? (
                <input
                  type="text"
                  value={editData.location}
                  onChange={(e) => handleInputChange('location', e.target.value)}
                  className="detail-input"
                />
              ) : (
                <span className="detail-value">{profileData.location}</span>
              )}
            </div>

            <div className="detail-group">
              <label className="detail-label">
                <User size={16} />
                Department
              </label>
              {isEditing ? (
                <input
                  type="text"
                  value={editData.department}
                  onChange={(e) => handleInputChange('department', e.target.value)}
                  className="detail-input"
                />
              ) : (
                <span className="detail-value">{profileData.department}</span>
              )}
            </div>

            <div className="detail-group">
              <label className="detail-label">
                <Calendar size={16} />
                Joined
              </label>
              <span className="detail-value">{profileData.joinDate}</span>
            </div>

            <div className="detail-group bio-group">
              <label className="detail-label">
                Bio
              </label>
              {isEditing ? (
                <textarea
                  value={editData.bio}
                  onChange={(e) => handleInputChange('bio', e.target.value)}
                  className="detail-textarea"
                  rows={4}
                />
              ) : (
                <span className="detail-value bio-text">{profileData.bio}</span>
              )}
            </div>
          </div>
        </div>

        <div className="account-stats">
          <h3>Account Statistics</h3>
          <div className="stats-grid">
            <div className="stat-card">
              <span className="stat-number">127</span>
              <span className="stat-label">Patients Managed</span>
            </div>
            <div className="stat-card">
              <span className="stat-number">89%</span>
              <span className="stat-label">Avg. Adherence Rate</span>
            </div>
            <div className="stat-card">
              <span className="stat-number">43</span>
              <span className="stat-label">Days Active</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyAccount;

